---
title: "Fit Check Ongoing"
date: 2025-12-17
category: "Engineering"
---

We completed a fit check of the major mechanical assemblies for our [dynamic test model](/blog/dynamic-test-model-manufacturing-readiness-review-complete), verifying that all components interface correctly before vibration and assembly testing.

![Fit check of optical bench and metering structure](/images/blog-fit-check/fit-check.jpg)

## What is a Fit Check?

A fit check is a critical verification step where we physically assemble major structural components to confirm that everything interfaces correctly. It's the difference between trusting the CAD model and proving it with hardware in hand. For the mass simulator, this step validates our assembly procedures before we run the unit through vibration testing.

## Optical Bench

The optical bench is the structural backbone of the telescope payload. It holds the primary mirror, focal plane array, and gyroscope. The mass simulator version replicates the mounting interfaces and mass properties of the flight design, letting us validate assembly sequences and tooling.

![Optical bench detail](/images/blog-fit-check/detail-1.png)

## Metering Structure

The metering structure maintains the critical spacing between the primary and secondary mirrors. This component holds the secondary mirror at the correct distance and orientation relative to the optical bench. During vibration testing, we'll validate that the metering structure's dynamic behavior matches our finite element models.

![Metering structure detail](/images/blog-fit-check/detail-2.png)

![Assembly detail](/images/blog-fit-check/detail-3.png)

![Assembly detail](/images/blog-fit-check/detail-4.png)

## What's Next

With fit check complete, the mass simulator moves into vibration testing. Data from these tests will correlate our structural models and validate our assembly procedures before we commit to flight hardware.
